import { admissionSteps } from '@/mocks/homeData';
import { useTranslation } from 'react-i18next';

export default function FacilityAccessSection() {
  const { t } = useTranslation();
  return (
    <section className="relative py-24 md:py-32 bg-background-100">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            FACILITY & ACCESS
          </p>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('home.facility.title')}
          </h2>
          <div className="gold-line mx-auto mb-4"></div>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 items-stretch">
          {/* Left: Facility Image & Info */}
          <div className="w-full lg:w-1/2">
            <div className="bg-background-50 border border-background-300/60 h-full">
              {/* Facility Image */}
              <div className="relative h-96 overflow-hidden">
                <img
                  src="/images/generated/facility-access-img.jpg"
                  alt={t('home.facility.imgAlt')}
                  title={t('home.facility.imgTitle')}
                  className="w-full h-full object-cover object-center"
                />
              </div>

              {/* Facility Info */}
              <div className="p-8">
                <h3 className="font-heading text-lg text-foreground-900 tracking-[0.06em] mb-5">
                  {t('home.facility.mainCampus')}
                </h3>
                <div className="space-y-3 text-[16px] text-foreground-700 leading-relaxed tracking-[0.03em]">
                  {String(t('home.facility.postal')).split(/\n{2,}/).map((__s, __i) => (<p key={__i}>{__s}</p>))}
                  {String(t('home.facility.address')).split(/\n{2,}/).map((__s, __i) => (<p key={__i}>{__s}</p>))}
                  <div className="pt-3 space-y-2">
                    <p className="text-[15px] text-foreground-600 flex items-start gap-2">
                      <i className="ri-train-line text-accent-600 mt-0.5"></i>
                      <span>
                        {t('home.facility.station1')}<strong className="text-foreground-800 font-medium">{t('home.facility.station1Name')}</strong>{t('home.facility.station1End')}
                      </span>
                    </p>
                    <p className="text-[15px] text-foreground-600 flex items-start gap-2">
                      <i className="ri-train-line text-accent-600 mt-0.5"></i>
                      <span>
                        {t('home.facility.station2')}<strong className="text-foreground-800 font-medium">{t('home.facility.station2Name')}</strong>{t('home.facility.station2End')}
                      </span>
                    </p>
                  </div>
                  {String(t('home.facility.reservationNote')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="pt-3 text-[14px] text-foreground-500 tracking-[0.04em]">{__s}</p>))}
                </div>
              </div>
            </div>
          </div>

          {/* Right: Admission Flow */}
          <div className="w-full lg:w-1/2">
            <div className="bg-background-50 border border-background-300/60 h-full p-8">
              <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-4 font-label">
                ADMISSION FLOW
              </p>
              <h3 className="font-heading text-lg text-foreground-900 tracking-[0.06em] mb-8">
                {t('home.facility.admissionTitle')}
              </h3>

              <div className="space-y-0">
                {admissionSteps.map((step, index) => (
                  <div key={index} className="relative">
                    <div className="flex gap-5 items-start py-6">
                      {/* Step Number */}
                      <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center border border-accent-500/40 text-accent-500">
                        <span className="font-heading text-sm tracking-[0.06em]">{step.step}</span>
                      </div>

                      {/* Content */}
                      <div className="flex-1">
                        <p className="section-title-en text-accent-500/50 text-[12px] tracking-[0.12em] mb-1">
                          {t(`home.admission.step${index}.titleEn`)}
                        </p>
                        <h4 className="font-heading text-[17px] text-foreground-900 tracking-[0.05em] mb-2">
                          {t(`home.admission.step${index}.title`)}
                        </h4>
                        <p className="text-[15px] text-foreground-600 leading-relaxed tracking-[0.03em]">
                          {t(`home.admission.step${index}.desc`)}
                        </p>
                      </div>

                      {/* Icon */}
                      <div className="w-9 h-9 flex items-center justify-center flex-shrink-0">
                        <i className={`${step.icon} text-lg text-accent-500/60`}></i>
                      </div>
                    </div>

                    {/* Connector Line */}
                    {index < admissionSteps.length - 1 && (
                      <div className="ml-[23px] w-[1px] h-6 bg-gradient-to-b from-accent-500/30 to-transparent"></div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}